/**
 * @file Actions for the notifications
 * @author Alwyn Tan
 */

import { createAction } from 'redux-actions'

export const loadNotifications = createAction('LOAD_NOTIFICATIONS')
export const updateNotifications = createAction('UPDATE_NOTIFICATIONS')
